import { useMemo, useState } from 'react'
import {
  getEntregasParaApurar,
  postExcelMultipleApuracao,
} from '../../../../services/api/https/deliveries/retorno.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SUCCESS: 'Apuração concluida, $QTE veiculos retornados com sucesso',
  UPLOAD_APURACAO: 'Efetuando Apuração',
}

const INITIAL_STATE = {
  loadingMessage: LOAD_MESSAGE.NONE,
  fileContent: {},
  itensApurados: null,
  errorMessage: null,
  selectedFormato: null,
}

export const ARQUIVO_FORMATOS = [
  { name: 'Vigor RAVEX', value: 1 },
  { name: 'Extrafruti', value: 2 },
  { name: 'Modelo Geral', value: 3 },
]

export default function useImportarApuracao() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      uploadImportacaoApuracao(tp_id, fileContent, selectedFormato) {
        postExcelMultipleApuracao(tp_id, {
          info: fileContent,
          type: selectedFormato.value,
          user_id: getUsuarioInfo().id,
        })
          .then(response =>
            setState(prevState => ({
              ...prevState,
              itensApurados: response.totalReturnedVehicles,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onFormatoArquivoChange(formato) {
        setState(prevState => ({ ...prevState, selectedFormato: formato }))
      },

      async onBtnImportarClick(content, selectedFormato, selectedTp) {
        if (!selectedTp) setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else if (!selectedFormato)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'É necessario escolher um modelo para exportar',
          }))
        else
          setState(prevState => ({
            ...prevState,
            fileContent: content,
            loadingMessage: LOAD_MESSAGE.UPLOAD_APURACAO,
          }))
      },

      async onBtnExportarExcel(selectedFormato, selectedTp) {
        const colunasVigorRavex = [
          [
            'Placa',
            'Numero NF',
            'Status NF',
            'Operador',
            'Transportadora',
            'Identificador',
            'Data da Anomalia',
          ],
        ]

        const colunasExtrafruti = [['Data Prevista', 'Placa']]

        if (!selectedFormato)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'É necessario escolher um modelo para exportar',
          }))
        else if (selectedFormato.value === 1) {
          gerarArquivoExcel('VigorRavex', colunasVigorRavex, `ModeloVigorRavex.xlsx`)
        } else if (selectedFormato.value === 2) {
          gerarArquivoExcel('Extrafruti', colunasExtrafruti, `ModeloExtrafruti.xlsx`)
        } else if (selectedFormato.value === 3) {
          if (selectedTp) window.open(await getEntregasParaApurar(selectedTp))
          else {
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Selecione um TP',
            }))
          }
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
